export const SPONSOR_DIAMANT = "diamant"
export const SPONSOR_OR = "or"
export const SPONSOR_PLATINE = "platine"
export const SPONSOR_ARGENT = "argent"
export const SPONSOR_BRONZE = "bronze"

export const sponsors = {
    [SPONSOR_DIAMANT]: {
        title: "sponsors.diamond",
        defaultMessage: "Diamond",
    },
    [SPONSOR_OR]: {
        title: "sponsors.gold",
        defaultMessage: "Gold",
    },
    [SPONSOR_PLATINE]: {
        title: "sponsors.platinum",
        defaultMessage: "Platinum",
    },
    [SPONSOR_ARGENT]: {
        title: "sponsors.silver",
        defaultMessage: "Silver",
    },
    [SPONSOR_BRONZE]: {
        title: "sponsors.bronze",
        defaultMessage: "Bronze",
    },
}

export const SPONSORS_ORDER = [
    SPONSOR_DIAMANT,
    SPONSOR_PLATINE,
    SPONSOR_OR,
    SPONSOR_ARGENT,
    SPONSOR_BRONZE,
]

export const SPONSOR_TITLES = {
    [SPONSOR_DIAMANT]: {
        title: "sponsors.diamond",
        defaultMessage: "Diamond",
    },
    [SPONSOR_OR]: {
        title: "sponsors.gold",
        defaultMessage: "Gold",
    },
    [SPONSOR_PLATINE]: {
        title: "sponsors.platinum",
        defaultMessage: "Platinum",
    },
    [SPONSOR_ARGENT]: {
        title: "sponsors.silver",
        defaultMessage: "Silver",
    },
    [SPONSOR_BRONZE]: {
        title: "sponsors.bronze",
        defaultMessage: "Bronze",
    },
}

export const SPONSORS = [
    {
        img: "ets.webp",
        link: "https://www.etsmtl.ca/",
        title: "sponsors.sp4",
        defaultMessageTitle: "École de technologie supérieure",
        type: SPONSOR_DIAMANT,
        colNum: "12",
        frontPageWidth: "20%"
    },
    // {
    //     img: "rousseau_blue_logo.webp",
    //     link: "https://www.rousseau.com/int_fr/",
    //     title: "sponsors.sp11",
    //     defaultMessageTitle: "Rousseau Metal International",
    //     type: SPONSOR_OR,
    //     colNum: "12",
    //     frontPageWidth: "20%"
    // },
    {
        img: "aeetslogo.webp",
        link: "http://aeets.com/",
        title: "sponsors.sp1",
        defaultMessageTitle: "ETS's Student Association",
        type: SPONSOR_DIAMANT,
        colNum: "12",
        frontPageWidth: "20%"
    },
    {
        img: "GENIUM360_LogoCoul_002.webp",
        link: "https://www.genium360.ca/fr-ca/",
        title: "sponsors.sp13",
        defaultMessageTitle: "Genium360",
        type: SPONSOR_OR,
        colNum: "12",
        frontPageWidth: "20%"
    },
    {
        img: "AC_Logo_Vertical_onWhiteTransparent.webp",
        link: "https://www.aircanada.com/",
        title: "sponsors.sp14",
        defaultMessageTitle: "Air Canada",
        type: SPONSOR_OR,
        colNum: "12",
        frontPageWidth: "20%"
    },
    {
        img: "aseq_logo.svg",
        link: "https://www.aseq.ca/",
        title: "sponsors.sp15",
        defaultMessageTitle: "Aseq",
        type: SPONSOR_BRONZE,
        colNum: "12",
        frontPageWidth: "20%"
    },      
    {
        img: "concord_logo_vertical.webp",
        link: "https://www.concordtours.ca/",
        title: "sponsors.sp16",
        defaultMessageTitle: "Concord Tours & Travel",
        type: SPONSOR_BRONZE,
        colNum: "12",
        frontPageWidth: "20%"
    }
]